module.exports = __webpack_public_path__ + "img/img-2-5.0deda2bd.png";